import React from 'react'

export const InboxEmptyState: React.FC = () => {
  return (
    <div className='inbox-empty-state'>
      <i className='fa-regular fa-envelope inbox-empty-state-icon' aria-hidden />
      <p className='inbox-empty-state-text'>Select a message to read</p>
    </div>
  )
}
